// React
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injections
import { notifyError } from '../../containers/componentsInjection';
import { ReportsInjection } from '../../containers/reportsInjection';

// View
import { ProposalsCardPrintingPage } from './view';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { APIClient } from '../../../../helpers/api_helper';
import { openPdfWithBase64 } from '../../../../utils/openPdfWithBase64';

export const ProposalsCardPrinting = () => {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState({
    cpfInput: '',
    proposal: '',
  });

  const [customerSelected, setCustomerSelected] = useState({});
  const [isOpenModal, setIsOpenModal] = useState();

  const { getOrderAssociates, associates } = ReportsInjection();

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  //fluxo:
  // - Pesquisa pessoa por cpf ou proposta (usar oq usamos pra o datatable de associados)
  // - Mostra a lista dos associados que encontrarem
  // - Clica na pessoa, e mostra a lista de propostas da pessoa
  // - Seleciona a proposta e clica em imprimir

  const handleSearch = async (event) => {
    toggleLoading();
    setSearch(event);
    await getOrderAssociates({
      page: 1,
      length: 10,
      search: event,
      order_column: 1,
      order_dir: 'asc',
    });

    setTimeout(() => {
      setShow(true);
      setLoading(false);
    }, 1000);
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      cpfInput: '',
      proposal: '',
    },
    validationSchema: Yup.object({
      cpfInput: Yup.string(),
      proposal: Yup.string(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        cpf: values.cpfInput || null,
        proposal_id: values.proposal || null,
        name: null,
        status_id: null,
      };
      handleSearch(valuesToSubmit);
    },
  });

  const handleGenerateReport = (params) => {
    toggleLoading();
    api
      .create('reports/proposal/card', params)
      .then((response) => {
        openPdfWithBase64(response.data, 'Impressão de cartão');
      })
      .catch((error) => {
        notifyError(error.response.data.messages.error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCardDependent = (hashid, proposalId) => {
    toggleLoading();
    api
      .create(`reports/proposal/card`, {
        proposal_id: proposalId,
        dependent_id: hashid,
      })
      .then((response) => {
        openPdfWithBase64(response.data, 'Impressão de cartão');
      })
      .catch((error) => {
        notifyError(error.response.data.messages.error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <ProposalsCardPrintingPage
      api={api}
      show={show}
      history={history}
      validation={validation}
      // Data
      isOpen={isOpenModal}
      search={search}
      setSearch={setSearch}
      associates={associates?.data}
      customerSelected={customerSelected}
      setCustomerSelected={setCustomerSelected}
      handleGenerateReport={handleGenerateReport}
      handleCardDependent={handleCardDependent}
      toggle={() => setIsOpenModal((prevState) => !prevState)}
    />
  );
};
